import { ConstipationFlows } from './Constipation/flows';
import { HemorrhoidFlows } from './Hemorrhoids & Anal Fissures/flows';
import { PruritusAniFlows } from './pruritusAni/flows';
import { LichenSclerosusFlows } from './LichenSclerosus/flow';


const rectalHealthFlows = {
  ...ConstipationFlows,
  ...PruritusAniFlows,
  ...HemorrhoidFlows,
  ...LichenSclerosusFlows
};
export default rectalHealthFlows;
